import _checkTypes from "check-types";
import _makeRequest2 from "./utils/makeRequest";
import _assignParams2 from "./utils/assignParams";
import _jsonParser2 from "./utils/jsonParser";
import _travelUtils2 from "./utils/travelUtils";
import _constants2 from "./config/constants";

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

/**
 * Modules from the community: package.json
 */
var check = _checkTypes;
/**
 * Internal modules
 */

var _makeRequest = _makeRequest2;
var _assignParams = _assignParams2;
var _jsonParser = _jsonParser2;
var _travelUtils = _travelUtils2;
var _constants = _constants2;
var ACCEPTED_PARAMS = _constants.ACCEPTED_PARAMS;
var GOOGLEMAPS_ENDPOINTS = _constants.GOOGLEMAPS_ENDPOINTS;
var MAX_REQUEST_LENGTHS = _constants.MAX_REQUEST_LENGTHS;
var METHOD_KEY = "directions";

exports = function (params, callback) {
  if (typeof callback !== "function") {
    throw new TypeError("callback must be present");
  }

  if (!((this || _global).config.google_client_id && (this || _global).config.google_private_key) && (this || _global).config.key == null) {
    return callback(new Error("The directions API requires a key. You can add it to the config."));
  }

  if (!check.object(params)) {
    return callback(new TypeError("params must be an object"));
  }

  var args = _assignParams({}, params, ACCEPTED_PARAMS[METHOD_KEY]); // validate directions specific args


  if (args.origin == null) {
    return callback(new Error("params.origin is required"));
  }

  if (args.destination == null) {
    return callback(new Error("params.destination is required"));
  } // validate common directions/distance-matrix args


  try {
    _travelUtils.validateCommonArgs(args);
  } catch (e) {
    return callback(e);
  }

  _travelUtils.convertTargetTimes(args);

  return _makeRequest((this || _global).request, (this || _global).config, GOOGLEMAPS_ENDPOINTS[METHOD_KEY], args, _jsonParser(callback), MAX_REQUEST_LENGTHS[METHOD_KEY]);
};

export default exports;